import { IssueCaseDoc, IssueCaseStatusCode, IssueSourceType } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeIssueCases } from 'src/utils/firebase/firebase-short-cut';

const useIssueCasesForOrder = (orderId: string | undefined) => {
  const [issueCases, setIssueCases] = useState<IssueCaseDoc[]>([]);

  useEffect(() => {
    if (orderId) {
      const subscription = observeIssueCases([
        ['sourceId', '==', orderId],
        ['sourceType', '==', IssueSourceType.ORDER],
        ['status', 'not-in', [IssueCaseStatusCode.DELETED, IssueCaseStatusCode.CANCELED]],
      ]).subscribe((docs) => {
        setIssueCases(docs.sort((a, b) => a._timeCreate.toDate().getTime() - b._timeCreate.toDate().getTime()));
      });
      return () => subscription.unsubscribe();
    } else {
      setIssueCases([]);
    }
  }, [orderId]);

  return issueCases;
};

export default useIssueCasesForOrder;
